import { render, staticRenderFns } from "./nav-bar-industrial.vue?vue&type=template&id=35ab8f36&scoped=true"
import script from "./nav-bar-industrial.vue?vue&type=script&lang=js"
export * from "./nav-bar-industrial.vue?vue&type=script&lang=js"
import style0 from "./nav-bar-industrial.vue?vue&type=style&index=0&id=35ab8f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab8f36",
  null
  
)

export default component.exports